import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.GasStation}-enter {
		.${Layouts.GasStation}-background {
			opacity: 0;
		}

		.${Layouts.GasStation} {
			transform: translateY(20px);
			opacity: 0;
		}
	}

	&.${Layouts.GasStation}-enter-active, &.${Layouts.GasStation}-exit {
		.${Layouts.GasStation}-background {
			opacity: 1;
		}

		.${Layouts.GasStation} {
			transform: translateY(0);
			opacity: 1;
		}
	}

	&.${Layouts.GasStation}-enter-done {
		.${Layouts.GasStation}-background {
			opacity: 1;
		}

		.${Layouts.GasStation} {
			transform: none;
			opacity: 1;
		}
	}

	&.${Layouts.GasStation}-exit-active {
		.${Layouts.GasStation}-background {
			opacity: 0;
		}

		.${Layouts.GasStation} {
			transform: translateY(20px);
			opacity: 0;
		}
	}
`;
